export const isMobileDevice = () => {
  // Check user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Mobile user agents
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;
  
  // Check screen size (mobile/tablet breakpoints)
  const isSmallScreen = window.innerWidth <= 768 || window.innerHeight <= 600;
  
  // Check touch capability
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Combine checks
  return mobileRegex.test(userAgent) || (isSmallScreen && isTouchDevice);
};

export const isTabletDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const tabletRegex = /iPad|Android(?!.*Mobile)|Tablet/i;
  const isTabletSize = window.innerWidth >= 768 && window.innerWidth <= 1024;
  
  return tabletRegex.test(userAgent) || isTabletSize;
};

export const getDeviceType = () => {
  if (isMobileDevice()) return 'mobile';
  if (isTabletDevice()) return 'tablet';
  return 'desktop';
};
